import ApiGetOptions from '@/datatypes/api-get-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class BillingInvoiceService extends ApiService {
  public list(params) {
    return this.call(new ApiGetOptions(
      {
        url: '/billing_provider_invoices',
        params: decamelizeKeysDeep(params),
      },
    ));
  }
}
